import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Navbar from "Components/Navbar/Navbar";
import SubNav from "Components/Navbar/SubNav/SubNav";
import TopBar from "Pages/Inspector/InspectorFi/components/TopBar";
import "Pages/Inspector/InspectorFi/styles/inspector.scss";

const ROLE_DASHBOARD: Record<string, string> = {
  admin: "/admin",
  gc: "/gc-dashboard",
  sub: "/lien-waiver",
  lender: "/bank-dashboard",
  owner: "/owner-dashboard",
  inspector: "/project-inspection",
};

export default function ProfileLayout() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}") as Record<
    string,
    string
  >;
  const role = user.role ?? "";
  const dashboardPath = ROLE_DASHBOARD[role] ?? "/";
  const firstName = user.firstName ?? "";
  const lastName = user.lastName ?? "";
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem("darkMode") === "true",
  );
  const toggleDark = () =>
    setDarkMode((d) => {
      localStorage.setItem("darkMode", String(!d));
      return !d;
    });

  if (role === "admin") {
    return (
      <div className={darkMode ? "dm" : ""}>
        <Navbar toggleDark={toggleDark} darkMode={darkMode} />
        <Outlet />
      </div>
    );
  }
  if (role === "inspector") {
    return (
      <div className="inspectorPage profileShell">
        <TopBar
          project={{ id: "", name: "", draw: "", inspection: "", bank: "", type: "", address: "", sub: "", meta: "" }}
          onDirections={() => {}}
          onSwitch={() => {}}
        />
        <Outlet />
      </div>
    );
  }

  const userName = `${firstName} ${lastName}`.trim() || "User";
  const userInitials =
    `${firstName[0] ?? ""}${lastName[0] ?? ""}`.toUpperCase() || "U";

  const roleLabel: Record<string, string> = {
    gc: "General Contractor",
    lender: user.companyName || "Lender",
    owner: "Owner / Borrower",
    inspector: "Inspector",
  };

  return (
    <div className={darkMode ? "dm" : ""}>
      <SubNav
        crumbs={[
          { label: "My Projects", onClick: () => navigate(dashboardPath) },
          { label: "My Profile" },
        ]}
        userName={userName}
        userInitials={userInitials}
        role={roleLabel[role] ?? role}
        crumbClass="crumbs"
        notifications
        showSignout
        toggleDark={toggleDark}
        darkMode={darkMode}
      />
      <Outlet />
    </div>
  );
}
